import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubnavMenu } from '~models/subnav-menu';
import { FeatureFlagService } from '~services/feature-flag.service';
import { Subscription, combineLatest } from 'rxjs';

const SubnavLabels = {
  contracts: 'Contracts',
  drivers: 'Drivers',
  suspendedDrivers: 'Suspended Drivers',
  driverSiteRestrictions: 'Driver site restrictions',
};

@Component({
  selector: 'sa-lmo-subcarrier-container',
  templateUrl: './lmo-subcarrier-container.component.html',
  styleUrls: ['./lmo-subcarrier-container.component.scss'],
})
export class LmoSubcarrierContainerComponent implements OnInit, OnDestroy {
  public subnavLabels = SubnavLabels;
  public subnavMenu: SubnavMenu[] = [{ label: this.subnavLabels.contracts, active: true }];
  public activeMenu = this.subnavLabels.contracts;

  private subs: Subscription[] = [];
  private addedDriverTabs = false;

  constructor(private featureFlagService: FeatureFlagService) {}

  ngOnInit(): void {
    const lmoBanDrivers$ = this.featureFlagService.isFlagActive('lmoBanDrivers');
    const allowDriverSiteRestriction$ = this.featureFlagService.isFlagActive('allowDriverSiteRestriction');

    this.subs.push(
      combineLatest([lmoBanDrivers$, allowDriverSiteRestriction$]).subscribe(
        ([enabledBanDriver, enabledRestrictDriver]) => {
          if (enabledBanDriver && !this.addedDriverTabs) {
            this.addedDriverTabs = true;
            this.subnavMenu.push(
              { label: this.subnavLabels.drivers, active: false },
              { label: this.subnavLabels.suspendedDrivers, active: false },
            );
          }
          if (
            enabledRestrictDriver &&
            !this.subnavMenu.find((menu) => menu.label === this.subnavLabels.driverSiteRestrictions)
          ) {
            this.subnavMenu.push({ label: this.subnavLabels.driverSiteRestrictions, active: false });
          }
        },
      ),
    );
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
